export const environment = {
  "GRAPHQL_URI": "https://stage-acs-chapterportal-apiapp-01-d6accyhxh2eeenea.centralus-01.azurewebsites.net",
  "GRAPHQL_WS_URI": "wss://stage-acs-chapterportal-apiapp-01-d6accyhxh2eeenea.centralus-01.azurewebsites.net",
  "GET_ROLE_API": "https://qa-services.facs.org/acs/api/CommitteeEx/GetRoleForChapterPortal",
  "REDIRECT_URI": "https://stage-acs-chapterportal-uiapp01-dkajexfsfhemgubc.centralus-01.azurewebsites.net/",
  "CLIENT_ID": "",
  "TENANT_ID": "",
  "CLIENT_AUTHORITY": "",
  "AUTH_TYPE": "okta",
  "NODE_ENV": "staging",
  "AUTOSAVE_DEBOUNCE_MS": 1200,
  "SEARCH_DEBOUNCE_MS": 800,
  "MIN_SEARCH_LENGTH": 3,
  "MJ_CORE_SCHEMA_NAME": "__mj",
  "production": false,
  "APPLICATION_NAME": "ChapterPortalUI",
  "APPLICATION_INSTANCE": "STAGE",
  "AUTH0_DOMAIN": "",
  "AUTH0_CLIENTID": "",
  "OKTA_DOMAIN": "https://login-qa.facs.org",
  "OKTA_CLIENTID": "0oaq36ij4gas6zVn41d7",
  "OKTA_ISSUER": "https://login-qa.facs.org/oauth2/default",
  "OKTA_REDIRECT_URI": "https://stage-acs-chapterportal-uiapp01-dkajexfsfhemgubc.centralus-01.azurewebsites.net/callback",
  "OKTA_SCOPES": ['openid', 'profile', 'email'],
  "SESSION_CONFIG": {
    "strategy": "auto_refresh",
    "warningMinutesBeforeExpiry": 5,
    "autoRefreshMinutesBeforeExpiry": 10,
    "maxRefreshAttempts": 3,
    "checkIntervalSeconds": 300
  },
  "ANNOUNCEMENT_POLLING": {
    "enabled": false,
    "intervalSeconds": 30,
    "urgentNotificationDuration": 8000,
    "highNotificationDuration": 5000
  }
};
